import React, { useState } from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/data';
import { GeneralEnquiryDialog } from '$partials/global';
import { useOffice } from '$contexts/office';
import getGoogleMapsKey from '$utilities/google-maps-key';
import GoogleMapReact from 'google-map-react';
import IconChevron from '$partials/icons/icon-chevron';
import IconMarker from '$partials/icons/icon-marker';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').OfficeContactBlock}
 */
const OfficeContactBlock = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const { contact } = useOffice();
    return (
        <div className='module-office-team'>
            <div className='layout-container layout-site-outer-padding py-35 sm:py-48 md:py-64'>
                {contact.title && (
                    <h2 className='type-style-2 mb-16 sm:mb-32'>
                        {contact.title}
                    </h2>
                )}
                <div className='-mx-layout-col'>
                    <div className='flex flex-wrap'>
                        <div className='w-full md:w-1/3 px-layout-col sm:px-0 md:px-layout-col sm:flex sm:flex-wrap md:block'>

                            {contact.address && (
                                <div
                                    className='rich-text mb-24 md:mb-48 sm:w-1/3 md:w-full sm:px-layout-col md:px-0'
                                    dangerouslySetInnerHTML={{
                                        __html: contact.address
                                    }}/>
                            )}
                            <div className='sm:w-2/3 md:w-full pb-8 sm:pb-32 sm:px-layout-col md:px-0'>
                                {/* Phone 1 */}
                                {(contact.primaryPhoneNumber && formatLinkBlockToUrl(contact.primaryPhoneNumber)) && (
                                    <div className='border-t border-main-border py-16'>
                                        <a
                                            className='flex items-center justify-between w-full type-style-eyebrow'
                                            href={formatLinkBlockToUrl(contact.primaryPhoneNumber)}>
                                            <span>
                                                {contact.primaryPhoneNumber.phone}
                                            </span>
                                            <IconChevron className='inline-block ml-5.5 -rotate-90' />
                                        </a>
                                    </div>
                                )}
                                {/* Phone 2 */}
                                {(contact.secondaryPhoneNumber && formatLinkBlockToUrl(contact.secondaryPhoneNumber)) && (
                                    <div className='border-t border-main-border py-16'>
                                        <a
                                            className='flex items-center justify-between w-full type-style-eyebrow'
                                            href={formatLinkBlockToUrl(contact.secondaryPhoneNumber)}>
                                            <span>
                                                {contact.secondaryPhoneNumber.phone}
                                            </span>
                                            <IconChevron className='inline-block ml-5.5 -rotate-90' />
                                        </a>
                                    </div>
                                )}
                                {/* Email */}
                                {(contact.officeEmail && formatLinkBlockToUrl(contact.officeEmail)) && (
                                    <div className='border-t border-main-border py-16'>
                                        <a
                                            className='flex items-center justify-between w-full type-style-eyebrow'
                                            href={formatLinkBlockToUrl(contact.officeEmail)}>
                                            <span>
                                                {contact.officeEmail.email}
                                            </span>
                                            <IconChevron className='inline-block ml-5.5 -rotate-90' />
                                        </a>
                                    </div>
                                )}
                            </div>
                            {/* Contact form */}
                            <div className='w-full sm:px-layout-col md:px-0 mb-32'>
                                <Button
                                    as='button'
                                    className='h-[44px] button-brand-filled px-16 rounded type-style-eyebrow flex items-center justify-center'
                                    onClick={() => setIsDialogOpen(true)}>
                                    Contact form
                                </Button>
                                {isDialogOpen && (
                                    <GeneralEnquiryDialog
                                        closeDialog={() => setIsDialogOpen(false)}
                                        defaultOffice={{
                                            id: contact.id,
                                            title: contact.title
                                        }}
                                        disclaimerText={contact.disclaimerText}
                                        isOpen={isDialogOpen}/>
                                )}
                            </div>
                        </div>
                        <div className='w-full md:w-2/3 px-layout-col aspect-square sm:aspect-[6/5] md:aspect-auto'>
                            {contact?.coordinates && (
                                <GoogleMapReact
                                    yesIWantToUseGoogleMapApiInternals
                                    bootstrapURLKeys={{
                                        key: getGoogleMapsKey(),
                                    }}
                                    defaultCenter={{
                                        lat: contact.coordinates?.lat,
                                        lng: contact.coordinates?.lng,
                                    }}
                                    defaultZoom={16}
                                    options={{
                                        mapId: 'ca9052da21cdf8f0b6ba14d4',
                                        disableDefaultUI: true,
                                        keyboardShortcuts: false,
                                    }}>
                                    <IconMarker
                                        lat={contact.coordinates?.lat}
                                        lng={contact.coordinates?.lng} />
                                </GoogleMapReact>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default OfficeContactBlock;
